import type { Media } from '@twilio/conversations';

import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchInfiniteConversationMessagesArgs } from '../api/types/conversations.types';

import {
  getInfiniteConversationMessages,
  getTotalUnreadMessagesCount,
  fetchConversationPreviews,
  getConversationBySid,
  getMessageMedia,
} from '../api/twilio';
import { getLinkPreview } from '../api/linkPreview.api';

export const conversationsQueryKeys = createQueryKeys('conversations', {
  getActiveConversationInstance: ({ id }: { id: string }) => ({
    queryFn: async () => {
      return await getConversationBySid(id);
    },
    queryKey: ['activeConversationInstance', id],
  }),
  getConversationPreviews: () => ({
    queryFn: async () => await fetchConversationPreviews(),
    queryKey: ['conversationPreviews'],
  }),
  getInfiniteMessages: ({
    conversation,
    pageParam,
    pageSize,
  }: FetchInfiniteConversationMessagesArgs) => ({
    queryFn: (pageParam: number) =>
      getInfiniteConversationMessages({
        conversation,
        pageParam,
        pageSize,
      }),
    queryKey: [
      'conversationMessages',
      conversation?.sid || 'null',
      pageParam ?? undefined,
    ],
  }),
  getMessageMedia: ({ media }: { media: Media[] }) => ({
    queryFn: async () => await getMessageMedia(media),
    queryKey: ['mediaUrls', media.map((m) => m.sid)],
  }),
  getLinkPreview: ({ url }: { url: string }) => ({
    queryFn: async () => await getLinkPreview({ url }),
    queryKey: ['linkPreview', url],
  }),
  getTotalUnreadMessagesCount: () => ({
    queryFn: async () => await getTotalUnreadMessagesCount(),
    queryKey: ['totalUnreadCount'],
  }),
});
